<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "Créer Un Nouveau" : "UPDATE" }} Compte</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- NAME -->
        <vs-input label="Nom " v-model="nom" class="mt-5 w-full" name="item-nom" v-validate="'required'" />
        <!-- <span class="text-danger text-sm" v-show="errors.has('item-nom')">Le nom est obligatoire</span> -->

        <!-- Prénom  -->
        <vs-input label="Prénom " v-model="prenom" class="mt-5 w-full" name="item-prenom" v-validate="'required'" />
        <!-- <span class="text-danger text-sm" v-show="errors.has('item-prenom')">Le prénom est obligatoire</span> -->

        <!-- Role -->
        <vs-select v-model="role" label="Role" class="mt-5 w-full" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in roles" />
          <!-- <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in roles" /> -->
        </vs-select>

        <!-- Email -->
        <vs-input icon-pack="feather" label="Nom d'utilisateur" type="email" v-model="email" class="mt-5 w-full" name="item-email" />
        <!-- <span class="text-danger text-sm" v-show="errors.has('item-email')" > Email n'est pas valide </span> -->
      </div>
    </VuePerfectScrollbar>

    <div class="mt-8 flex flex-wrap items-center justify-end">
      <vs-button @click="submitData" :disabled="!isFormValid">Ajouter</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
    </div>

    <div class="flex flex-wrap items-end p-6">
      <div class="w-1/3"></div>
      <vs-button class="mr-5" @click="submitData" :disabled="!isFormValid">Ajouter</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleDataList from "@/store/data-list/moduleDataList.js";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let { nom, id, prenom, role, email } = JSON.parse(JSON.stringify(this.data));
        this.id = id;
        this.nom = nom;
        this.prenom = prenom;
        this.email = email;
        this.role = role.value;
        this.initValues();
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
  },
  data() {
    return {
      id: null,
      nom: "",
      prenom: "",
      role: "",
      email: "",
      roles: [
        {
          text: "Pharmacien",
          value: "Admin",
        },
        {
          text: "Aide pharmacien",
          value: "Simple",
        },
      ],

      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return !this.errors.any() && this.nom && this.prenom && this.role && this.email;
    },
  },
  methods: {
    initValues() {
      if (this.data.id) return;
      this.id = null;
      this.nom = "";
      this.prenom = null;
      this.role = "";
      this.email = "";
    },
    created() {
      if (!moduleDataList.isRegistered) {
        this.$store.registerModule("dataList", moduleDataList);
        moduleDataList.isRegistered = true;
      }
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const obj = {
            //id: this.id,
            nom: this.nom,
            prenom: this.prenom,
            role: this.role,
            email: this.email,
          };

          if (this.dataId !== null && this.dataId >= 0) {
            this.$store.dispatch("dataList/updateItem", obj).catch((err) => {
              console.error(err);
            });
          } else {
            // delete obj.id
            // obj.popularity = 0
            console.log(obj);
            this.$vs.loading();

            this.$store
              .dispatch("dataList/addCompte", obj)
              .then(() => {
                this.$vs.loading.close();

                this.$swal.fire({
                  position: "absolute",
                  icon: "success",
                  title: "Le compte a été ajoute avec succes.",
                  showConfirmButton: false,
                  timer: 1500,
                });
              })
              .catch((err) => {
                this.$vs.loading.close();

                if (err.response.status == "406") {
                  this.$swal.fire({
                    position: "absolute",
                    icon: "error",
                    title: "Utilisateur avec cet email déja existe",
                    showConfirmButton: true,
                  });
                } else {
                  this.$swal.fire({
                    position: "absolute",
                    icon: "error",
                    title: "Erreur inconnu",
                    showConfirmButton: true,
                  });
                }
                console.error(err);
              });
          }

          this.$emit("closeSidebar");
          this.initValues();
        }
      });
    },
  },
  components: {
    VuePerfectScrollbar,
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
